import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "@/contexts/AuthContext";

const DISABLED_ERROR = "ACCOUNT_DISABLED";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export { DISABLED_ERROR };
